import { Component, OnInit } from '@angular/core';

import { EventService } from '../core/services/event.service';
import {
  LAYOUT_VERTICAL, LAYOUT_HORIZONTAL, LAYOUT_TWOCOLUMN, LAYOUT_MODE, LAYOUT_WIDTH,
  LAYOUT_POSITION, SIDEBAR_SIZE, SIDEBAR_COLOR, TOPBAR
} from './layout.model';

import { PreferenceService, PreferenceType } from '../core/services/preference.service';
import { Subscription } from 'rxjs';
import { ThemeModel } from '../core/models/preference/theme-model';
import { LanguageService } from '../core/services/language.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

/**
 * Layout Component
 */
export class LayoutComponent implements OnInit {

  layoutType!: string;
  pref: PreferenceType;

  constructor(
    private eventService: EventService, 
    private userPreferenceService: PreferenceService,
    private languageService: LanguageService ) { }

  ngOnInit(): void {
    // this.layoutType = LAYOUT_HORIZONTAL;

    // document.body.setAttribute('layout',this.layoutType)

    // // listen to event and change the layout, theme, etc
    // this.eventService.subscribe('changeLayout', (layout) => {
    //   this.layoutType = layout;      
    // });

     // listen to event and change the layout, theme, etc
    this.eventService.subscribe('changeLayout', (layout) => {
      this.layoutType = layout;

      if (this.pref) {
        this.pref.theme.layout = layout;
        this.userPreferenceService.updateThemePreference(this.pref).subscribe();
      }
    });

    this.userPreferenceService.currentPreference
      .subscribe((data: PreferenceType) => {
        if (data) {
          this.layoutType = data.theme.layout;
          document.body.setAttribute('layout', this.layoutType);
          this.pref = data;
        }
      });
  
      this.userPreferenceService.getPreference();
  }

  /**
  * Check if the vertical layout is requested
  */
   isVerticalLayoutRequested() {
    return this.layoutType === LAYOUT_VERTICAL;
  }

  /**
   * Check if the horizontal layout is requested
   */
   isHorizontalLayoutRequested() {
    return this.layoutType === LAYOUT_HORIZONTAL;
  }

  /**
   * Check if the horizontal layout is requested
   */
   isTwoColumnLayoutRequested() {
    return this.layoutType === LAYOUT_TWOCOLUMN;
  }

}
